import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import {
  AboutHero,
  AboutStory,
  AboutValues,
  AboutLeadership,
} from '../../components/about';
import UpdatesSection from '../../components/feature/UpdatesSection';

export default function About() {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Safety First',
      description: 'Zero-harm culture with comprehensive HSE protocols and continuous training programs.',
    },
    {
      icon: 'ri-leaf-line',
      title: 'Environmental Responsibility',
      description: 'Minimizing our footprint through sustainable practices and innovative technologies.',
    },
    {
      icon: 'ri-team-line',
      title: 'Integrity & Transparency',
      description: 'Ethical operations with open communication to all stakeholders and communities.',
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Innovation',
      description: 'Embracing cutting-edge technology to improve efficiency and reduce environmental impact.',
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Community Partnership',
      description: 'Creating shared value through local employment, education, and infrastructure development.',
    },
    {
      icon: 'ri-trophy-line',
      title: 'Excellence',
      description: 'Delivering superior results through technical expertise and operational discipline.',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <AboutHero />
      <AboutStory />
      <AboutValues values={values} />
      <AboutLeadership />
      <UpdatesSection bgColor="bg-[#F9F9F9]"/>
      <Footer />
    </div>
  );
}
